module.exports = __webpack_public_path__ + "img/bookIcon.04f9c264.png";